<!--SO>More>ShipmentMaintenance页面-->
<template>
    <a-modal :maskClosable="false" title="Shipment Maintenance" :footer="null" width="80%" :visible="visible" @cancel="close">
        <a-row :gutter="10">
            <a-col>
                Shipment#
                <a-input size="small" v-model="shipmentNo" style="width: 200px;margin-right: 10px;" @pressEnter="search"/>
                <a-button type="primary" size="small" style="border-radius: 6px;" @click="search">Search</a-button>
            </a-col>
        </a-row>
        <a-row style="border: 1px solid gray;border-radius: 6px;margin-top: 10px;" v-for="(item,index) in maintenanceList">
            <a-row style="cursor: pointer;background-color: #A54990;size: 26px;padding: 3px;border-radius: 6px;color: white;padding-right: 10px;padding-left: 10px;">
                <a-col @click="item.isShow = !item.isShow,currentItemIndex = index">
                    <a-col span="8">{{item.title}}</a-col>
                    <a-col span="8" style="text-align: center;">Selected:{{item.selected}} | Outstanding:{{item.outstanding}}</a-col>
                    <a-col span="8" style="text-align: right;">Shipment:{{item.shipment == null ? '0' : item.shipment}}</a-col>
                </a-col>
            </a-row>
            <el-collapse-transition>
                <a-row :gutter="20" style="padding: 10px;" v-show="!item.isShow">
                    <a-col span="12">
                        <a-row>Selected Orders / Pick Requests</a-row>
                        <a-row v-for="(itemEtd,index) in item.listEtd" style="border: 1px solid gray;border-radius: 6px;margin-top: 10px;">
                            <a-row style="margin: 5px;padding: 5px;">
                                <a-col span="1">
                                    <a-checkbox v-model="itemEtd.isChecked" @change="checkOrder(itemEtd)"></a-checkbox>
                                </a-col>
                                <a-col span="5">ETD:{{itemEtd.etd}}</a-col>
                                <a-col span="15" style="font-weight: bold;">
                                    ({{itemEtd.orders}} Orders / {{itemEtd.weight}} Kgs / {{itemEtd.cbm}} CBM)
                                </a-col>
                                <a-col span="3" style="text-align: right;padding-right: 10px;"><a href="#" @click="itemEtd.isShow = !itemEtd.isShow,currentEtdIndex = index">{{itemEtd.isShow == false ? 'Hide' : 'Show'}}</a></a-col>
                            </a-row>
                            <el-collapse-transition>
                                <a-row style="text-align: center;border-top: 1px solid gray;padding: 5px;" v-show="!itemEtd.isShow">
                                    <a-row style="font-weight: bold;">
                                        <a-col span="1"></a-col>
                                        <a-col span="7" style="text-align: left;">Order</a-col>
                                        <a-col span="5"># of Carton(s)</a-col>
                                        <a-col span="5">Weight(KGs)</a-col>
                                        <a-col span="5">Volume(CBM)</a-col>
                                    </a-row>
                                    <a-row v-for="(itemEtdOrder,index) in itemEtd.listEtdOrder" style="margin-left: -2px;">
                                        <a-col span="1"><a-checkbox v-model="itemEtdOrder.isChecked"></a-checkbox></a-col>
                                        <a-col span="7" style="text-align: left;">{{itemEtdOrder.relId}}</a-col>
                                        <a-col span="5">{{itemEtdOrder.cartons}}</a-col>
                                        <a-col span="5">{{itemEtdOrder.weight}}</a-col>
                                        <a-col span="5">{{itemEtdOrder.cbm}}</a-col>
                                    </a-row>
                                </a-row>
                            </el-collapse-transition>
                        </a-row>
                    </a-col>
                    <a-col span="12">
                        <a-row style="color: cornflowerblue;">Available Shipment</a-row>
                        <a-row v-for="(itemShipment,index) in item.listShipment" style="text-align: center;line-height: 3vh;margin-top: 10px;">
                            <a-col span="2" style="background-color: #A54990;height: 6vh;width: 6vh;border-radius: 6px;cursor: pointer;" @click="addShipment(item,itemShipment),currentShipmentIndex = index">
                                <img style="height: 100%;width: 100%;" src="../../../assets/img/add.png">
                            </a-col>
                            <a-col span="22" style="border: 1px solid gray;border-radius: 6px;">
                                <row style="cursor: pointer;" :style="itemShipment.isShow == false ? 'border-bottom: 1px solid gray':'border-bottom: 0px solid gray'">
                                    <a-col span="10" style="font-weight: bold;" @click="itemShipment.isShow = !itemShipment.isShow,currentShipmentIndex = index">
                                        <a-row style="height: 3vh;border-bottom: 1px solid gray;">
                                            <a-col span="3"><img style="height: 2.2vh;width: 2.2vh;cursor: pointer;" src="../../../assets/img/landmark.png"></a-col>
                                            <a-col span="21" style="text-align: left" @click.stop>
                                                <a-select style="width: 100%;" size="small" v-model="itemShipment.state" :placeholder="$t('publicLang.PleaseSelect')">
                                                    <a-select-option v-for="item in item.countryState" :value="item.value">
                                                        {{item.title}}
                                                    </a-select-option>
                                                </a-select>
                                            </a-col>
                                        </a-row>
                                        <a-row style="height: 3vh;text-align: left">
                                            <a-col span="3"></a-col>
                                            <a-col span="21" style="text-align: left">{{itemShipment.shipmentNo}}</a-col>
                                        </a-row>
                                    </a-col>
                                    <a-col span="2" style="height: 6vh;color: cornflowerblue;border-left: 1px solid gray;border-right: 1px solid gray;" @click="itemShipment.isShow = !itemShipment.isShow,currentShipmentIndex = index">
                                        {{itemShipment.cartons}}<br>
                                        CTN
                                    </a-col>
                                    <a-col span="5" @click="itemShipment.isShow = !itemShipment.isShow,currentShipmentIndex = index">
                                        <a-row style="height: 3vh;border-bottom: 1px solid gray;border-right: 1px solid gray;">{{itemShipment.weight}} Kgs</a-row>
                                        <a-row style="height: 3vh;border-right: 1px solid gray;">{{itemShipment.cbm}} CBM</a-row>
                                    </a-col>
                                    <a-col span="7" @click="itemShipment.isShow = !itemShipment.isShow,currentShipmentIndex = index">
                                        <a-col @click.stop>
                                            <a-date-picker size="small" style="width: 100%;" format="YYYY-MM-DD" v-model="itemShipment.date" @change="selectedDate(itemShipment)"></a-date-picker>
                                        </a-col>
                                        <a-col>
                                            {{itemShipment.week}}
                                        </a-col>
                                    </a-col>
                                </row>
                                <el-collapse-transition>
                                    <a-row v-show="!itemShipment.isShow">
                                        <a-row v-for="(itemShipmentOrder,indexso) in itemShipment.listShipmentOrder"  style="border: 1px solid gray;border-radius: 6px;margin: 10px;text-align: left;padding-left: 10px;">
                                            <a-col span="10">{{itemShipmentOrder.relId}}</a-col>
                                            <a-col span="6">{{itemShipmentOrder.weight}} Kgs</a-col>
                                            <a-col span="6">{{itemShipmentOrder.cbm}} CBM</a-col>
                                            <a-col span="1">
                                                <img style="height: 3vh;width: 3vh;cursor: pointer;" src="../../../assets/img/del.png" @click="deleteShipment(itemShipmentOrder.relId,itemShipment.shipmentNo),itemShipment.listShipmentOrder.length == 1 ? currentShipmentIndex = -1 : currentShipmentIndex = index">
                                            </a-col>
                                        </a-row>
                                    </a-row>
                                </el-collapse-transition>
                            </a-col>
                        </a-row>
                        <a-row style="text-align: center;line-height: 3vh;margin-top: 10px;">
                            <a-col span="1" style="background-color: #FFB24E;height: 6vh;width: 6vh;border-radius: 6px;cursor:pointer;" @click="addShipment(item),currentShipmentIndex = item.listShipment.length">
                                <img style="height: 100%;width: 100%;" src="../../../assets/img/add.png">
                            </a-col>
                            <a-col span="22" style="border: 1px solid gray;border-radius: 6px;">
                                <a-col span="10">
                                    <a-row style="height: 3vh;border-bottom: 1px solid gray;">
                                        <a-col span="3"><img style="height: 2.2vh;width: 2.2vh;cursor: pointer;" src="../../../assets/img/landmark.png"></a-col>
                                        <a-col :span="21" style="text-align: left">
                                            <a-select style="width: 100%;" size="small" v-model="item.newState" :placeholder="$t('publicLang.PleaseSelect')">
                                                <a-select-option v-for="item in item.countryState" :value="item.value">
                                                    {{item.title}}
                                                </a-select-option>
                                            </a-select>
                                        </a-col>
                                    </a-row>
                                    <a-row style="height: 3vh;text-align: left">
                                        <a-col span="3"></a-col>
                                        <a-col span="21" style="text-align: left"></a-col>
                                    </a-row>
                                </a-col>
                                <a-col span="2" style="height: 6vh;color: cornflowerblue;border-left: 1px solid gray;border-right: 1px solid gray;">
                                    0<br>
                                    CTN
                                </a-col>
                                <a-col span="5">
                                    <a-row style="height: 3vh;border-bottom: 1px solid gray;border-right: 1px solid gray;">0 Kgs</a-row>
                                    <a-row style="height: 3vh;border-right: 1px solid gray;">0 CBM</a-row>
                                </a-col>
                                <a-col span="7">
                                    <a-col>
                                        <a-date-picker size="small" style="width: 100%;" format="YYYY-MM-DD" v-model="item.newDate" @change="selectedAddDate(item)"></a-date-picker>
                                    </a-col>
                                    <a-col>
                                        {{item.newWeek}}
                                    </a-col>
                                </a-col>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </el-collapse-transition>
        </a-row>
    </a-modal>
</template>

<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import Template from "../reportCom/template";
    import moment from "moment";

    export default{
        components:{
            Template
        },
        data(){
            return{
                visible:false,
                maintenanceList:[],
                orderNos:"",
                shipmentNo:"",
                currentItemIndex:-1,
                currentEtdIndex:-1,
                currentShipmentIndex:-1,
                state:'',
            }
        },
        created() {

        },
        methods:{
            show(sos){
                this.maintenanceList = []
                this.visible = true
                this.orderNos = sos
                this.query();
            },
            close(){
                this.visible = false
                this.currentItemIndex = -1
                this.currentEtdIndex = -1
                this.currentShipmentIndex = -1
                this.shipmentNo = ""
                this.countryState = []
            },
            search(){
                this.currentItemIndex = -1
                this.currentEtdIndex = -1
                this.currentShipmentIndex = -1
                this.query()
            },
            query(){
                let params = {
                    sos: this.orderNos,
                    shipmentNo:this.shipmentNo
                }
                ajax.get(api.GETMAINTENANCELIST,params).then(res=>{
                    this.maintenanceList = res.data;
                    if(this.maintenanceList.length > 0){
                        if(this.maintenanceList.length == 1){
                            this.currentItemIndex = 0
                        }
                        if(this.currentItemIndex >= 0){
                            this.maintenanceList[this.currentItemIndex].isShow = false
                            if(this.maintenanceList[this.currentItemIndex].listEtd.length > 0){
                                if(this.maintenanceList[this.currentItemIndex].listEtd.length == 1){
                                    this.currentEtdIndex = 0
                                }
                                if(this.currentEtdIndex >= 0){
                                    this.maintenanceList[this.currentItemIndex].listEtd[this.currentEtdIndex].isShow = false
                                }
                            }
                            if(this.maintenanceList[this.currentItemIndex].listShipment.length > 0){
                                if(this.maintenanceList[this.currentItemIndex].listShipment.length == 1){
                                    this.currentShipmentIndex = 0
                                }
                                if(this.currentShipmentIndex >= 0){
                                    this.maintenanceList[this.currentItemIndex].listShipment[this.currentShipmentIndex].isShow = false
                                }
                            }
                        }
                        for (let i = 0; i < this.maintenanceList.length; i++) {
                            for (let j = 0; j < this.maintenanceList[i].listShipment.length; j++) {
                                this.selectedDate(this.maintenanceList[i].listShipment[j])
                            }
                        }
                    }
                })
            },
            clickTitle(){
                this.showTitle = !this.showTitle;
            },
            checkOrder(item){
                for (let i = 0; i < item.listEtdOrder.length; i++) {
                    if(item.isChecked){
                        item.listEtdOrder[i].isChecked = true
                    }else {
                        item.listEtdOrder[i].isChecked = false
                    }
                }
            },
            addShipment(item,itemShipment){
                let orderNos = [];
                for (let i = 0; i < item.listEtd.length; i++) {
                    for (let j = 0; j < item.listEtd[i].listEtdOrder.length; j++) {
                        if(item.listEtd[i].listEtdOrder[j].isChecked){
                            orderNos.push(item.listEtd[i].listEtdOrder[j].relId)
                        }
                    }
                }
                if(orderNos.length < 1){
                    this.$customMessage.warning(this.$t('publicLang.PleaseOneLeast'), 2);
                    return;
                }
                let expDate = ''
                let state = ''
                if(itemShipment != null && itemShipment.shipmentNo != null){//追加
                    if(itemShipment.date.length < 1){
                        this.$customMessage.warning(this.$t('expDeliveryDateNotnull'), 2);
                        return;
                    }
                    expDate = itemShipment.date
                    state = itemShipment.state
                }else{//新建
                    if(item.newDate.length < 1){
                        this.$customMessage.warning(this.$t('expDeliveryDateNotnull'), 2);
                        return;
                    }
                    expDate = item.newDate
                    state = item.newState
                }
                let param = {
                    orderNos : orderNos,
                    shipmentNo : itemShipment == null ? '' : itemShipment.shipmentNo,
                    expDeliveryDate:moment(expDate).format('YYYY-MM-DD HH:mm:ss'),
                    state:state,
                }
                ajax.post(api.ADDMAINTENANCELIST, param).then(res => {
                    if (res.code == 200) {
                        this.$message.success(this.$t('cfs.operationSuccess'),2)
                        item.newDate = ''
                        item.newWeek = ''
                        this.query()
                    } else {
                        this.$customMessage.warning(res.msg,2);
                    }
                })
            },
            deleteShipment(relId,shipmentNo){
                let orderNos = [];
                orderNos.push(relId)
                let param = {
                    orderNos : orderNos,
                    shipmentNo : shipmentNo,
                    deleteLoading: false
                }
                let that = this
                ajax.post(api.DELETEMAINTENANCELIST, param).then(res => {
                    if (res.code == 200) {
                        this.$message.success(this.$t('cfs.operationSuccess'),2)
                        this.query()
                    } else {
                        if(res.msg = 'Loading'){
                            param.deleteLoading = true
                            this.$customConfirm({
                                title: this.$t('confirmDeleteLoading'),
                                content: "",
                                onOk() {
                                    ajax.post(api.DELETEMAINTENANCELIST, param).then(res => {
                                        if (res.code == 200) {
                                            that.$message.success(res.msg)
                                            that.query()
                                        } else {
                                            that.$customMessage.warning(res.msg);
                                        }
                                    })
                                }
                            });
                        }else{
                            this.$customMessage.warning(res.msg,2);
                        }
                    }
                })
            },
            selectedDate(itemShipment){
                let selectDays = moment(itemShipment.date).format('YYYY-MM-DD')
                let week = new Date(selectDays).getDay();//星期
                itemShipment.week = this.getWeek(week);
            },
            selectedAddDate(item){
                let selectDays = moment(item.newDate).format('YYYY-MM-DD')
                let week = new Date(selectDays).getDay();//星期
                item.newWeek = this.getWeek(week);
            },
            getWeek(days){//获取星期几
                let week;
                switch(days) {
                    case 1:
                        week = 'Monday';
                        break;
                    case 2:
                        week = 'Tuesday';
                        break;
                    case 3:
                        week = 'Wednesday';
                        break;
                    case 4:
                        week = 'Thursday';
                        break;
                    case 5:
                        week = 'Friday';
                        break;
                    case 6:
                        week = 'Saturday';
                        break;
                    case 0:
                        week = 'Sunday';
                        break;
                }
                return week;
            }
        }
    }
</script>

<style scoped>
    /*明细出场动画*/
    .v-enter,.v-leave-to{
        opacity: 0;
        transform: translateY(50%);
    }
    .v-enter-active,.v-leave-active{
        transition: all 0.5s ease;
    }
</style>